import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.routes')
  .factory('$route', RouteObjectFactory);

function RouteObjectFactory($bringozFactory: $bringozFactory,
                            RoutesAPI: BringozApi,
                            Routes_DS: DataStoreConfig,
                            Routes_PN: PushNotificationsConfig) {

  function $route(id: string) {
    return $bringozFactory(id, RoutesAPI, Routes_DS, Routes_PN);
  }

  return $route;
}
